<template lang="pug">

  .sosBuild
    | {{ version }}

</template>

<script>
  import { version } from '@/constants'

  export default {
    name: 'SosVersion',

    data () {
      return {
        version: version,
      }
    },
  }
</script>

<style lang="sass" scoped>

  .sosBuild
    z-index: 7
    position: fixed
    bottom: 7px
    left: 7px
    font-weight: 600
    font-size: 12px
    line-height: 12px
    color: lightgreen
    text-shadow: 1px 1px 2px black
    text-align: center
    background-color: black
    padding: 4px 5px
    border-radius: 4px

</style>
